import { render, staticRenderFns } from "./MaintenancePeriod.vue?vue&type=template&id=0dc3137d"
import script from "./MaintenancePeriod.vue?vue&type=script&lang=ts"
export * from "./MaintenancePeriod.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports